export const getAuthAdminAccess = () => {
  // Check if running in iframe
  const isInIframe = window.self !== window.top;

  // If in iframe, bypass authentication (static token will be used in API calls)
  if (isInIframe) {
    return true;
  }

  // Otherwise, use normal authentication check
  let toketGet: any = localStorage.getItem("oogw.ai_user");
  return toketGet && toketGet?.length > 0;
};

export const dateFormater = (date: any) => {
  return new Date(date).toLocaleString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' }).replace(/\s/g, '-')
}

export const truncateText = (text: string, maxLength: number) => {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + '...';
};


type RawDataRow = Record<string, any>;

export function flattenDataRows(data: RawDataRow[]): RawDataRow[] {
  const flattened: RawDataRow[] = [];

  for (const row of data) {
    const arrayFields = Object.entries(row).filter(
      ([, value]) => Array.isArray(value) && value.every(item => typeof item === 'string')
    );

    if (arrayFields.length === 0) {
      flattened.push(row);
    } else {
      const [key, array] = arrayFields[0]; // Only flattening one array field per row
      if (array.length === 0) {
        flattened.push({ ...row, [key]: '' });
      } else {
        for (const item of array) {
          flattened.push({ ...row, [key]: item });
        }
      }
    }
  }

  return flattened;
}


export const maskName = (name: string) => {
  const getEmail = localStorage.getItem("oogw.ai_user_email");
  if (getEmail === "patelnasib06@gmail.com" || getEmail === "demo@oogw.ai") {
    if (!name || name.length <= 2) return name; // nothing to mask if too short
    const visibleStart = name.slice(0, 2);
    const mask = '*'.repeat(name.length - 4);
    return `${visibleStart}${mask}`;
  } else {
    return name;
  }
};